import React, { useState } from "react";
import TextArea from "antd/es/input/TextArea";
import "../float-input/FloatInput.css";

const FloatingTextArea = ({
  label,
  size = "middle",
  width = "100%",
  customStyles = {},
  ...props
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const getTextFromReactNode = (node) => {
    if (typeof node === "string") return node;
    if (Array.isArray(node)) return node?.map(getTextFromReactNode)?.join("");
    if (node?.props?.children) return getTextFromReactNode(node.props.children);
    return "";
  };

  return (
    <div
      className={`floating-text-area-container ${size}`}
      style={{
        width,
        position: "relative",
        ...customStyles,
      }}
    >
      <label
        className={`floating-label ${
          isFocused || props.value ? "focused" : ""
        }`}
        style={{
          "--label-font-size": customStyles["--label-font-size"] || "66px",
          "--label-focused-font-size":
            customStyles["--label-focused-font-size"] || "12px",
          "--label-color": customStyles["--label-color"] || "#333333",
          "--label-focused-color":
            customStyles["--label-focused-color"] || "#f10c0c",
          "--label-focused-top": customStyles["--label-focused-top"] || "0px",
          "--label-focused-z-index":
            customStyles["--label-focused-z-index"] || 0,
          paddingLeft: customStyles["--label-padding-left"] || 0,
        }}
      >
        {label}
      </label>
      <TextArea
        {...props}
        size={size}
        onFocus={() => setIsFocused(true)}
        onBlur={(e) => setIsFocused(e.target.value !== "")}
        placeholder={!isFocused ? getTextFromReactNode(label) : ``}
        style={{
          "--input-border-color":
            customStyles["--input-border-color"] || "#333333",
          height: customStyles["--input-height"] || "120px",
          "--input-border-color-focused":
            customStyles["--input-border-color-focused"] || "#0c0c0c",
          fontWeight: customStyles["--input-font-weight"] || 400,
          paddingTop: customStyles["--input-padding-top"] || 0,
        }}
      />
    </div>
  );
};

export default FloatingTextArea;
